//////////////////////////////////////
// LOCAL CLINICS CAROUSEL

(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.local-clinics-carousel');
    if (!blocks.length) return;

    blocks.forEach((block) => {
      new Swiper(block.querySelector('.swiper'), {
        slidesPerView: 1.15,
        spaceBetween: 12,
        navigation: {
          prevEl: block.querySelector('.prev'),
          nextEl: block.querySelector('.next'),
        },
        breakpoints: {
          782: {
            slidesPerView: 2.2,
            spaceBetween: 16,
          },
          961: {
            slidesPerView: 3.2,
            spaceBetween: 20,
          },
        },
      });
    });
  });
})();
